import { put, call, all, takeLatest, select } from "redux-saga/effects";
import * as api from "../../../utils/api";
import moment from "moment";
import { requestRSPList, receiveRSPList, failRSPList } from "./actions";
import * as actions from "../../Authentication/redux/actions";

function* fetchRSPListWorker({ payload }) {
  try {
    const {
      startDate,
      endDate,
      pageNo,
      searchQuery,
      sortDir,
      sortingNo
    } = payload;

    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

    const body = {
      PageType: "Y",
      PageRow: 10,
      PageNo: pageNo,
      FundNo: 0,
      SortingNo: sortingNo,
      SortDirection: sortDir,
      StartDate: formattedStartDate,
      EndDate: formattedEndDate
    };

    if (searchQuery) {
      body["UnitholderId"] = searchQuery;
    }

    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const response = yield call(
      api.post,
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/dashboard-rsp`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        }
      }
    );
    if (response.status === 401) {
      yield put(actions.autoSignOut()); 
      return; 
    }
    
    if (response && response.data && response.data.data) {
      yield put(receiveRSPList(response.data));
    } else {
      
      yield put(failRSPList());
    }
  } catch (error) {
    
    yield put(failRSPList());
  }
}

export function* rspListSaga() {
  yield all([takeLatest(requestRSPList, fetchRSPListWorker)]);
}
